import { c, classy } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
/**
 * Use in `FieldLabel` to denote required fields.
 */
export const Asterisk = withRef(function Asterisk({ className, ...restProps }, ref) {
    return (React.createElement("abbr", { ...restProps, ref: ref, className: classy(c('asterisk'), className) }, ' *'));
});
//# sourceMappingURL=asterisk.js.map